export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    // handle error, e.g. report to a service
    console.error("plugin/ErrorHandler Error ", error);
    console.error("pluin/ErrorHandler Instance ", instance);
    console.error("pluin/ErrorHandler Info ", info);
    // clearError({ reirect: "/products/search" });
  };
});
